export default function getTransition(props: string[], duration = 150) {
  return {
    transitionDelay: '0ms',
    transitionDuration: `${duration}ms`,
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionProperty: props.join(','),
  };
}
